import { Markdown } from '@repo/ui/src/components/Markdown';
import Accordion, { AccordionItem } from '@repo/ui/src/components/Accordion';

interface Props {
  title: string;
  markdown: string;
  disclaimerText: string;
  markdownComponents?: any;
}

const ExpandableContentWithMarkdown = ({
  title,
  markdown,
  disclaimerText,
  markdownComponents,
}: Props) => {
  return (
    <Accordion allowZeroExpanded>
      <AccordionItem key={`base_accordion_${title}`} heading={title}>
        <div className="tw-my-6">
          <Markdown bodySize="large" components={markdownComponents}>
            {markdown}
          </Markdown>
        </div>
        <p className="tw-text-warm-500">{disclaimerText}</p>
      </AccordionItem>
    </Accordion>
  );
};

export default ExpandableContentWithMarkdown;
